import { createSelector } from "reselect";
import { RootState } from "../reducers/root";
import { HLA_RESULT_INACTIVATION_NAMESPACE } from "../actions/hla-result-inactivation";
import { PrivacyDomain } from "../types/shared/v2/PrivacyDomain";
import { ObjectHeader, StoreObject } from "../util/objects";
import { HLAResultInactivation } from "../types/shared/v2/HLAResult";
import { ClassName } from "../types/shared/v1/ClassName";

export const selectHLAResultInactivations = (state: RootState): { [objectId: string]: StoreObject<HLAResultInactivation> | ObjectHeader } | undefined => {
  return state.objects.byNamespace[HLA_RESULT_INACTIVATION_NAMESPACE]?.byDomain[PrivacyDomain.Public]?.byId
};

export const selectHLAResultInactivationObjects = createSelector(
  selectHLAResultInactivations,
  (items) => {
    if (!items) return [];
    return Object.values(items).reduce((arr: StoreObject<HLAResultInactivation>[], object) => {
      if (("data" in object)) {
        arr.push(object)
      }
      return arr;
    }, []);
  }
)

export const selectPatientHLAResultInactivationObjects = createSelector(
  [selectHLAResultInactivationObjects, (state: RootState, inlogId: string) => inlogId],
  (hlaResultInactivations, inlogId) => {
    return hlaResultInactivations.filter(obj => obj.data.ref.patient.inlogId === inlogId)
  }
)

export const selectPatientAndClassHLAResultInactivationObjects = createSelector(
  [
    selectPatientHLAResultInactivationObjects,
    (state: RootState, inlogId: string, classname: ClassName) => classname
  ],
  (hlaResultInactivations, classname) => {
    return hlaResultInactivations.filter(obj => obj.data.ref.hlaResult.class === classname)
  }
)